import './ComparisonTable.css'

const ComparisonTable = ({ table }) => {
  if (!table || !table.headers || !table.rows) return null

  return (
    <div className="comparison-table-wrapper">
      <table className="comparison-table">
        <thead>
          <tr>
            {table.headers.map((header, i) => (
              <th key={i}>{header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {table.rows.map((row, i) => (
            <tr key={i}>
              {table.headers.map((header, j) => (
                <td key={j}>
                  {header === 'Bewertung' && typeof row[header] === 'string' ? (
                    <span className="rating-badge">{row[header]}</span>
                  ) : (
                    row[header] || '-'
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default ComparisonTable

